<template>
	<div class="item" :id="detial.uuid" :style="{height: 'calc( 100% - ' + detial.itemStyle.interval + 'px )',borderWidth: detial.itemStyle.borderWidth + 'px',borderStyle: detial.itemStyle.borderStyle,borderColor: detial.itemStyle.borderColor,padding: detial.itemStyle.paddingVertical + 'px ' + detial.itemStyle.paddingHorizontal + 'px',marginBottom: detial.itemStyle.interval + 'px',borderRadius: detial.itemStyle.borderRadius + 'px',backgroundColor: detial.itemStyle.backgroundColor}">
		<div class="label" v-show="detial.showLabel" :style="{width: detial.labelStyle.width + 'px',textAlign: detial.labelStyle.textAlign == '居左'?'left': detial.labelStyle.textAlign == '居中'?'center':'right'}">
			<i v-if="detial.topic_required" class="required">*</i>
			<span class="txt" :style="{fontSize: detial.labelStyle.fontSize + 'px',color: detial.labelStyle.color,fontWeight: detial.labelStyle.fontWight,fontStyle: detial.labelStyle.fontStyle,textDecoration: detial.labelStyle.textDecoration}">{{detial.topicName}}</span>
		</div>
		<div class="cont">
			<div class="avatar">
				<el-upload class="avatar-uploader" ref="pictureUpload" action="/com/uplaod_modelimg.do" :file-list="detial.value" accept="image/*" list-type="picture-card" :limit="detial.allowNum" :before-upload="beforeImgUpload" :on-success="handleImgSuccess" :on-exceed="masterFileMax">
					<div class="item-cont" slot="file" slot-scope="{file}">
						<img class="el-upload-list__item-thumbnail" :src="file.modelimg" alt="" >
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
								<i class="el-icon-zoom-in"></i>
							</span>
							<span class="el-upload-list__item-delete" @click="handleRemove(file)" >
								<i class="el-icon-delete"></i>
							</span>
						</span>
					</div>
					<i class="el-icon-plus avatar-uploader-icon"></i>
					<div class="txt">{{detial.inputStyle.text}}</div>
				</el-upload>
			</div>
		</div>
		<el-dialog :visible.sync="dialogVisible">
			<img width="100%" :src="dialogImageUrl" />
		</el-dialog>
	</div>
</template>
<script>
import $ from "jquery";
export default {
	props: {
		detial: {
			type: Object,
		},
	},
	data() {
		return {
			dialogImageUrl: '',
			dialogVisible: false,
			formToken: sessionStorage.getItem('token')?sessionStorage.getItem('token'):'',
		};
	},
	methods: {
		handleRemove(file) {
			this.$refs.pictureUpload.uploadFiles.splice(this.$refs.pictureUpload.uploadFiles.findIndex((item) => {return item == file}),1);
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},	
		// 上传前的校验
		beforeImgUpload(file){
			const isLt5M = file.size / 1024 / 1024 < this.detial.allowSize;
			if (!isLt5M) {
				this.$message.error(`大小不能超过 ${this.detial.allowSize}MB!`);
			}
			return isLt5M;
		},
		masterFileMax() {
			this.$message.error(`请最多上传 ${this.detial.allowNum} 个文件。`);
		},
		handleImgSuccess(){console.log(this.$refs.pictureUpload)
			// this.detial.value = res.data.modelimg;
			this.detial.value = this.$refs.pictureUpload.uploadFiles;
			this.detial.value.forEach((file,index)=>{
				this.detial.value[index] = {
					...file,
					modelimg:file.response.data.modelimg
				}
			})
			const styleStr = this.detial.inputStyle;
			$("#" + this.detial.uuid + " .avatar .el-upload-list--picture-card .el-upload-list__item").css({
				width: styleStr.size + "px",
				height: styleStr.size + "px",
				borderColor: styleStr.borderColor,
			})
		}
	},
	watch: {
		"detial.inputStyle": {
			handler() {
				this.$nextTick(function () {
					const styleStr = this.detial.inputStyle;
					$("#" + this.detial.uuid + " .avatar-uploader .el-upload").css({
						width: styleStr.size + "px",
						height: styleStr.size + "px",
						borderWidth: styleStr.borderWidth + "px",
						borderStyle: styleStr.borderStyle,
						borderColor: styleStr.borderColor,
						borderRadius: styleStr.borderRadius + "px",
						backgroundColor: styleStr.backgroundColor,
						fontSize: styleStr.fontSize + "px",
						color: styleStr.color,
						fontWeight: styleStr.fontWight,
						fontStyle: styleStr.fontStyle,
					});
					$("#" + this.detial.uuid + " .avatar-uploader .avatar-uploader-icon").css({
						fontSize: styleStr.fontSize * 2 + "px",
					});
					$("#" + this.detial.uuid + " .avatar-uploader .txt").css({
						textDecoration: styleStr.textDecoration,
					});
					$("#" + this.detial.uuid + " .avatar .el-upload-list--picture-card .el-upload-list__item").css({
						width: styleStr.size + "px",
						height: styleStr.size + "px",
						borderColor: styleStr.borderColor,
					})
				});
			},
			deep: true,
			immediate: true,
		},
	},
};
</script>
<style lang="less" scoped>
.item {
	display: flex;
	.label {
		max-width: 100%;
		line-height: 40px;
		.required {
			color: #f56c6c;
			margin-right: 4px;
		}
	}
	::v-deep .cont {
		flex: 1;
		display: flex;
		margin: 0 0 0 10px;
		.avatar {
			display: flex;
			.avatar_item {
				margin: 0 10px 0 0;
				img {
					display: block;
					width: 100%;
					height: 100%;
					object-fit: contain;
				}
			}
			.avatar-uploader {
				display: flex;
				.el-upload {
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					width: 140px;
					height: 140px;
					line-height: unset;
					border: 1px dashed #ddd;
					border-radius: 4px;
					background-color: #fff;
					font-size: 14px;
					color: #999;
					.avatar-uploader-icon {
						font-size: 28px;
						color: inherit;
					}
					.txt {
						margin: 10px 0 0;
					}
					&:hover {
						border-color: var(--theme-custom-color) !important;
						color: var(--theme-custom-color) !important;
					}
				}
				.el-upload-list{
					margin: 0 0 -16px;
					.item-cont{
						width: 100%;
						height: 100%;
						.el-upload-list__item-thumbnail{
							object-fit: contain;
						}
					}
				}
			}
		}
	}
}
</style>